module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/attachmentpoints/attachmentpoints-multiple-delete/attachmentpoints-multiple-delete.component.css
// module id = ./src/app/attachmentpoints/attachmentpoints-multiple-delete/attachmentpoints-multiple-delete.component.css
// module chunks = main